import Cookies from 'js-cookie';

export default class CookieUtil {
  static getItem(key) {
    return Cookies.get(key);
  }

  static setItem(key, val, expirationDate) {
    if (val !== undefined) {
      return Cookies.set(key, val, {
        path: window.location.pathname,
        expires: expirationDate || 3650,
      });
    }
    return undefined;
  }

  static removeItem(key) {
    Cookies.remove(key, { path: window.location.pathname });
  }
}
